// Copyright 2024 Sorama B.V.
import { WorkflowModeService } from "services/WorkflowModes/WorkflowModeService";

export class Overview {
    constructor(private readonly workflowModeService: WorkflowModeService) {}
}
